import { Combobox } from '@/global/components/Combobox'
import localeText from '@/locales/datagrid'
import FilterModelPro, {
    GridFilterItemPro,
    GridFilterModelPro,
} from '../utils/filterModelPro'
import { GridColDefPro } from '../utils/types'

export default function FieldColuna({
    columns = [],
    item,
    onFilterModelChange,
    className,
}: {
    columns: GridColDefPro[]
    item: GridFilterItemPro
    onFilterModelChange: React.Dispatch<
        React.SetStateAction<GridFilterModelPro>
    >
    className?: string
}) {
    columns = columns.filter(f => f.filterable !== false)

    const opcoes = columns.map(column => ({
        value: column.field,
        label: column.headerName ?? '',
    }))

    return (
        <Combobox
            label={localeText.filterPanelColumn}
            variant="outlined"
            size="small"
            options={opcoes}
            value={opcoes.find(o => o.value === item.columnField) ?? null}
            className={className}
            onChange={opcao => {
                if (!opcao) return
                const valor = opcao.value

                onFilterModelChange(prev => ({
                    ...prev,
                    items: prev.items.map(p =>
                        p.id === item.id
                            ? (() => {
                                  const defaultOperatorForColumn =
                                      FilterModelPro.getDefaultOperator(
                                          columns.find(c => c.field === valor)
                                              ?.type,
                                      )

                                  return {
                                      ...p,
                                      columnField: valor,
                                      operatorValue:
                                          defaultOperatorForColumn ??
                                          p.operatorValue,
                                  }
                              })()
                            : p,
                    ),
                }))
            }}
        />
    )
}
